/**
 * Shared helpers for the storage cards on the File Explorer page
 * (FileManagerCard + StorageUsageCard).
 */

// Prefixes whose contents are referenced elsewhere (email docs, Andrei chat
// messages, CKEditor HTML). Read-only in the storage UI.
export const PROTECTED_ROOTS = ['mail', 'andrei_attachments', 'ckeditor_uploads'];

export const isProtected = (p: string): boolean =>
  PROTECTED_ROOTS.some((root) => p === root || p.startsWith(`${root}/`));

export const joinPath = (base: string, name: string): string => (base ? `${base}/${name}` : name);

export const fmtBytes = (n?: number): string => {
  if (n === undefined) return '—';
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  if (n < 1024 * 1024 * 1024) return `${(n / (1024 * 1024)).toFixed(1)} MB`;
  return `${(n / (1024 * 1024 * 1024)).toFixed(2)} GB`;
};

export const fmtDate = (iso?: string): string => {
  if (!iso) return '—';
  const d = new Date(iso);
  return isNaN(d.getTime()) ? '—' : d.toLocaleString('en-AU', { dateStyle: 'medium', timeStyle: 'short' });
};

export const fileIcon = (name: string, contentType?: string): string => {
  const ct = contentType || '';
  if (ct.startsWith('image/')) return 'bi-file-earmark-image text-info';
  if (ct.startsWith('video/')) return 'bi-file-earmark-play text-info';
  if (ct.startsWith('audio/')) return 'bi-file-earmark-music text-info';
  if (ct === 'application/pdf') return 'bi-file-earmark-pdf text-danger';
  const ext = name.split('.').pop()?.toLowerCase() || '';
  if (['zip', 'gz', 'rar', '7z'].indexOf(ext) !== -1) return 'bi-file-earmark-zip text-warning';
  if (['doc', 'docx'].indexOf(ext) !== -1) return 'bi-file-earmark-word text-primary';
  if (['xls', 'xlsx', 'csv'].indexOf(ext) !== -1) return 'bi-file-earmark-spreadsheet text-success';
  if (['js', 'ts', 'json', 'html', 'css', 'ttf', 'woff', 'woff2'].indexOf(ext) !== -1) return 'bi-file-earmark-code text-muted';
  return 'bi-file-earmark text-muted';
};
